<script>
import appConfig from "@/app.config";
import formcombobox from "../../FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import {required} from "vuelidate/lib/validators";  
import formtreeselect from "@/router/views/FormComponet/formtreeselect.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import IndexModalEdit from "./IndexModalEdit.vue";
 
export default {
  mixins: [Api, Sabit],
    props:["TanimId"],
  page: {
    title: "Stratejik Amaçlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    formcombobox,
    formtreeselect,
    forminput,
    IndexModalEdit


  },
  data() {
    return {
      
       FormData:{
            Id: "",
            Tablodetayid: "",
            Tablodetayparametreid: null,
            Hesaplamayontemi:null,
            Sirano: 0,
            Deleted: false,   
          },
          FormDataType:{ 
          Tablodetayid:{FieldName:"Tablodetayid",Field:"combobox",FieldTitle:"Gösterge",ComboDataArray:[]},
          Tablodetayparametreid:{FieldName:"Tablodetayparametreid",Field:"combobox",FieldTitle:"Parametre",ComboDataArray:[]},  
          Hesaplamayontemi:{FieldName:"Hesaplamayontemi",Field:"combobox",FieldTitle:"Hesaplama Yöntemi",ComboDataArray:[]},       
          Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetayParametre.AddEdit.Sirano'),FieldType:"number"},
        },
     
      islem:"",
      TableData:[],
      parametreler:[],
      hesaplama_gizle:0,
      DataUpdate:"",
       AddEdit:"",
      FormTitle:"",
      gosterge:"",
      FilitrelemePenceresi: false,
      Filter:{ 
        Aciklama:""
      },
           hesap_yontemleri: [
          { Id:"1",  Value:"Kayıt Sayısı" },
          { Id:"2",  Value:"Değer Toplamı" }
        ],
      
      DefaultPage:1,  

      Page: {
          PageNumber: "1",
          PageSize: "10",
          PageDataSize: "1", 
      },


    };
  },

      validations:{ 
        FormData: {
          Tablodetayparametreid: { required },
          Hesaplamayontemi: {},
          Sirano: {required}
        } 
    },

 watch: {

    TableData() {
      this.hesaplama_kontrol();
    },
  },

   methods:{

     onSubmit() {
      this.$v.$touch();
    
      if (!this.$v.$invalid) {

              this.FormData.Tablodetayid=this.TanimId;
               this.$delete(this.FormData, "Id");

           
              this.Post("StrPerfTablolarDetayParametre", this.FormData).then((res) => {
                  if(res){
                  this.FormData.Tablodetayparametreid=null;
 
                  if(this.FormData.Hesaplamayontemi == 1){
this.FormData.Hesaplamayontemi=null;
                  this.FormData.Hesaplamayontemi = this.FormData.Hesaplamayontemi + 1;
                  }else{
                    this.FormData.Hesaplamayontemi=null;
                  }

                  }
              });

 
         
      }
    },

       Get(){   

         this.ActionsGet({"Service":"StrPerfTablolarDetay/"+ this.TanimId,"Page":this.Page}).then(res => { 
                this.gosterge = res.Data.Gostergesi;   
                this.Page.PageDataSize = res.TotalCount;
              });

              let Page= {
        PageNumber: "1",
        PageSize: "999"
      }
          let Filter = "&Tablodetayid=" + this.TanimId + "&Asc=Sirano" ;
          this.ActionsFilterGet({Service:"StrPerfTablolarDetayParametre", Page:Page, Filter:Filter}).then(
            (res) => {
              this.TableData = res.Data;

            }
          );

    


 
      }, 

      yontem_yukle(parametre_id){

            let tipValue;
            //alert(parametre_id)
            for( var s=0; s<this.parametreler.length; s++){
              if (this.parametreler[s].Id==parametre_id){
          
                 tipValue= this.parametreler[s].tipValue;
              }
            }

            this.FormDataType.Hesaplamayontemi.ComboDataArray=[];
      
            for(var i=0; i<this.hesap_yontemleri.length; i++)
            {
               if(this.hesap_yontemleri[i].Id==2 && tipValue!="Sayı"){
                  console.log("1");
               }else{
                this.FormDataType.Hesaplamayontemi.ComboDataArray.push ({Id:this.hesap_yontemleri[i].Id,Value:this.hesap_yontemleri[i].Value})
               }

            }
        
      },

      hesaplama_kontrol(){
        this.hesaplama_gizle=0;
        for (var i=0; i< this.TableData.length; i++){
            if (this.TableData[i].Hesaplamayontemi!=null && this.TableData[i].Hesaplamayontemi!=""){
              this.hesaplama_gizle=1;
            }
        }

      },

        rightDrawer() {
        this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
      } ,



   },
   created() {

           let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
      let Filter="&Asc=Parametreadi";
         this.ActionsFilterGet({"Service":"StrPerfTablolarDetayParametreTanim","Page":Page,"Filter":Filter}).then(res => {  
        this.parametreler=res.Data;
        for(var i=0; i<this.parametreler.length; i++)
          {
            this.FormDataType.Tablodetayparametreid.ComboDataArray.push ({
              id:this.parametreler[i].Id,
              label:this.parametreler[i].Parametreadi})
          }    
      }); 



   },

};
</script>


<template>
<Loader>

   <div class="card">
          <div class="card-body"> 


                  <Form  @submit.prevent="onSubmit" > 
                       <div class="row">
                         <div class="col-md-12">

                           <div class="row">
                            <div class="col-md-12">
                            <h5> {{gosterge}} </h5>
                            </div>
                           </div>

                        <div class="row">
                            <div class="col-md-12">
                             


                                <formtreeselect
                                  :FormDataType="FormDataType.Tablodetayparametreid"
                                  :Value="FormData.Tablodetayparametreid"
                                  :v="$v.FormData.Tablodetayparametreid"
                                  @input="FormData.Tablodetayparametreid = $event, yontem_yukle(FormData.Tablodetayparametreid)"
                                />

                                <formcombobox
                                  v-if="hesaplama_gizle==0"
                                  :title_position="'d-block'"
                                  :labels_lg="3"
                                  :FormDataType="FormDataType.Hesaplamayontemi"
                                  :Value="FormData.Hesaplamayontemi"
                                  :v="$v.FormData.Hesaplamayontemi"
                                  @input="FormData.Hesaplamayontemi = $event"
                                />
                                <forminput style="width:250px" 
                                :FormDataType="FormDataType.Sirano" 
                                :Value="FormData.Sirano"
                                :v="$v.FormData.Sirano" 
                                @input="FormData.Sirano = $event" />

                            </div>
                        </div>

                         </div>
                            </div>

                    <hr>
                          
                       
                            <button class="btn btn-primary" style="width:100px"  type="submit" > {{ $t("StrPerfTablolarDetayParametre.AddEdit.Button") }} </button> 

                          </Form>  
          </div>
   </div>   


    <div class="col-12">
      <div class="card">
          <div class="card-body"> 

              <div class="table-responsive">
              <table  class="table mb-0">
                <thead  class="table-light">
                  <tr>            
                    <th scope="col">{{ $t("StrPerfTablolarDetayParametre.Table.Sirano") }}</th>       
                     <th scope="col">{{ $t("StrPerfTablolarDetayParametre.Table.j_Parametreadi") }}</th>
                     <th scope="col">{{ $t("StrPerfTablolarDetayParametre.Table.Hesaplamayontemi") }}</th>
                    <th scope="col">{{ $t("StrPerfTablolarDetayParametre.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="Data in TableData" :key="Data.Id" >
                    <td>{{Data.Sirano}}</td>
                    <td>{{Data.j_Parametreadi}}</td>
                    <td style="width:200px">

                      <div v-for="yontemler in hesap_yontemleri"   :key="yontemler.Id"
                      :value="yontemler.Id"> <div v-if="yontemler.Id==Data.Hesaplamayontemi">{{ yontemler.Value  }} </div></div> 

                    </td>
                     
                    <td style="width:100px">  
                      <i
                        style="margin-left:10px"
                        v-b-modal.IndexModalEdit @click="DataUpdate = Data"
                        class="fas fa-pen"
                      >
                      <i
                        style="margin-left:10px"
                        @click="Delete('StrPerfTablolarDetayParametre', Data.Id)"
                        class="fas fa-trash-alt"
                      >
                      </i>

                      </i>
                    </td>
                  </tr>
                  
                </tbody>
              </table>

 <br>

              <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage" 
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
              >
              </b-pagination>


            </div>

          </div>
      </div>
    </div>


    <IndexModalEdit :Id="DataUpdate" @TableUpdate="Get" />
      

  </Loader>
</template>

